import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Alarm } from 'src/app/utils/interfaces/new/alarm.interface';
import { AlarmsPatient } from 'src/app/utils/interfaces/new/alarms-patient.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';
import { SnackbarService } from '../snackbar/snackbar.service';
import { DestinataireAlarme } from 'src/app/utils/interfaces/new/destinataire-alarmes.interface';
@Injectable({
  providedIn: 'root'
})
export class AlarmsService {

  private isMock = environment.mock;
  private _wait = (ms) => new Promise(res => setTimeout(res, ms));
  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  constructor(
    private http: HttpClient,
    private _filtresService: FiltresService,
    private _snack: SnackbarService
  ) { }

  public async find(filtre: Filtres = {
    perpage: -1,
    currentPage: 1,
  }, params?: any): Promise<Paginated<Alarm>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(filtre);
      const res = await this.http.get(`${environment.basePath}/medical/alarmes`, { params, ...this.httpOptions }).toPromise();
      const alarmes = res.body as Alarm[];
      const paginated: Paginated<Alarm> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: alarmes
      };
      return paginated;
    } catch (error) {
      if (error)
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async updateStatus(statut: DestinataireAlarme) {
    try {
      const res = await this.http.put(`${environment.basePath}/medical/alarmes/${statut.idAlarme}/status`, statut, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async delete(alarme: AlarmsPatient): Promise<void> {
    try {
      alarme.disabled = true;
      const res = await this.http.put(`${environment.basePath}/medical/alarmes/${alarme.id}/status`, alarme, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
